export default __webpack_public_path__ + "static/media/buster_klein_11.c2960fb1.jpg";